// import React, { useEffect, useRef, useState } from "react";
// import { connect } from "react-redux";
// import UserLayout from "./UserLayout";
// import { useForm } from "react-hook-form";
// import { changePasswordAction } from "../../../redux/actions/user/userAction";
// import axiosInstance from "../../authentication/helper/axiosApi";
// import { error } from "jquery";

// export const AccountSettings = (props) => {
//   const {
//     register,
//     handleSubmit,
//     watch,
//     formState: { errors },
//     reset,
//   } = useForm();
//   // console.log(errors);
//   const [oldPassword, setOldPassword] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPwd, setShowConfirmPwd] = useState(false);
//   const password = useRef({});
//   password.current = watch("password", "");
  
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const onSubmit = async (data, event) => {
//     //const dateTime = new Date().toISOString();
//     // console.log(data);
//     //console.log(dateTime)
//     //data.updated_at = dateTime
//     console.log(data)
    
//     if (Object.keys(errors).length === 0) {
//       try {
//         const response = await axiosInstance.post(
//           `/api/user/changePassword/${props?.user?.id}/`,
//           data
//         );
//         // console.log("Password change response:", response);
//         if (
//           response.data.Message ===
//           "Your password has been successfully changed"
//         ) {
//           alert(response.data.Message);
//           reset();
//         } else {
//           alert(response.data.Error);
//         }
//       } catch (error) {
//         console.log("Error changing password:", error);
//       }
//     }
//   };

//   return (
//     <UserLayout>
//       <div className="right-section">
//         <div className="row align-items-end mb-65">
//           <div className="col-sm-12 col-12">
//             <div className="banner">
//               <div className="banner-title-overlay">
//                 <h5 style={ isMobile ? { paddingTop: "40px", marginLeft: "-10px"} : {}}>
//                   <span>
//                     MY
//                     <br />
//                     <b>Account</b>
//                     <hr
//                       style={{
//                         height: "5px",
//                         background: "white",
//                         width: "75%",
//                       }}
//                     />
//                   </span>
//                 </h5>
//                 <img
//                   src="\assets\images\icons\myAccountIcon.png"
//                   className="icon-image "
//                 />
//               </div>

//               <img
//                 className="banner-image"
//                 src="\assets\images\Asset 1.png"
//                 alt="Not Found"
//               />
//             </div>

//             {/* <div className="myAccount-banner">
//               <div class="banner-content">
//                 <h5 className="banner-title">
//                   MY <br />
//                   <strong>Account </strong>
//                   <hr style={{ height: "10px", background: "white",width:'75%' }} />
//                 </h5>&nbsp;&nbsp;
//                 <span className="icon ">
//                   <img src="\assets\images\icons\myAccountIcon.png" alt="" />
//                 </span>
//               </div>
//               <div className="banner-img">
//               <img
//                 className="banner-image"
//                 src="\assets\images\Asset 1.png"
//                 alt="Not Found"
//               /> 
//               </div>
//             </div> */}
//           </div>
//         </div>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <div className="row margin-row">
//             <div className="col-12 card-block">
//               <div className="card-border">
//                 <div className="row">
//                   <div className="col cmb-25">
//                     <h3>Change Password</h3>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">Old Password</label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <input
//                       type={oldPassword ? "text" : "password"}
//                       className="form-control"
//                       id="old_password"
//                       placeholder="Old Password"
//                       name="old_password"
//                       autoComplete="off"
//                       {...register("old_password", {
//                         required: "Old Password is Required",
//                       })}
//                     />
//                     <div className="input-group-append">
//                       <button
//                         onClick={() => setOldPassword(!oldPassword)}
//                         className="btn btn-outline-secondary"
//                         type="button"
//                       >
//                         Show
//                       </button>
//                     </div>
//                   </div>
//                   <p
//                     style={{
//                       color: "red",
//                       marginLeft: "51%",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {errors.old_password?.message}
//                   </p>
//                 </div>
//                 {/* <p
//                   style={{ color: "red", fontSize: "14px", float: "right" }}
//                   className="col-md-5 col-10"
//                 >
//                   {errors.old_password?.message}
//                 </p> */}
//                 <br></br>
//                 <div className="row ">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">New Password</label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className="form-control"
//                       id="password"
//                       placeholder="Password"
//                       name="password"
//                       autoComplete="off"
//                       {...register("password", {
//                         required: "Password is Required",
//                         minLength: {
//                           value: 8,
//                           message: "Password must have at least 8 characters",
//                         },
//                         pattern: {
//                           value: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(.*\W.*)/g,
//                           message:
//                             "Please Enter a one lower, one upper, one digit and one special character",
//                         },
//                         // pattern: { value: /[A-Z]/g, message: "Please Enter a upper character" },
//                         // pattern: { value: /[0-9]/g, message: "Please Enter atleast one digit" },
//                       })}
//                     />

//                     <div className="input-group-append">
//                       <button
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="btn btn-outline-secondary"
//                         type="button"
//                       >
//                         Show
//                       </button>
//                     </div>
//                     {/* <p style={{ color: "red" }}>{errors.password?.message}</p> */}
//                   </div>
//                   <p
//                     style={{
//                       color: "red",
//                       marginLeft: "51%",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {errors.password?.message}
//                   </p>
//                 </div>
//                 {/* <p style={{ color: "red", fontSize: '14px', float: 'right' }} className="col-md-5 col-10">{errors.password?.message}</p> */}
//                 <br></br>
//                 <div className="row ">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">Confirm Password</label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <input
//                       type={showConfirmPwd ? "text" : "password"}
//                       className="form-control"
//                       id="confirmpassword"
//                       placeholder="Confirm Password"
//                       name="confirmpassword"
//                       autoComplete="off"
//                       {...register("confirmPassword", {
//                         required: "Confirm Password is Required",
//                         validate: (value) =>
//                           value === password.current ||
//                           "The passwords do not match",
//                       })}
//                     />
//                     <div className="input-group-append">
//                       <button
//                         onClick={() => setShowConfirmPwd(!showConfirmPwd)}
//                         className="btn btn-outline-secondary"
//                         type="button"
//                       >
//                         Show
//                       </button>
//                     </div>
//                   </div>{" "}
//                   <p
//                     style={{
//                       color: "red",
//                       marginLeft: "51%",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {errors.confirmPassword?.message}
//                   </p>
//                 </div>
//                 {/* <p style={{ color: "red", fontSize: '14px', float: 'right' }} className="col-md-5 col-10">{errors.confirmPassword?.message}</p> */}
//                 <br></br>
//                 <div className="cmb-25" style={{ float: "right" }}>
//                   <button type="submit" className=" btn btn-blue">
//                     Submit
//                   </button>
                  
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>
//     </UserLayout>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;

//   return {
//     user: user,
//     user: user,
//   };
// };
// const mapDispatchToProps = (dispatch) => {
//   return {
//     changePassword: (data, id) => dispatch(changePasswordAction(data, id)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);


//////////////////Delete////////////////////////////



import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import UserLayout from "./UserLayout";
import { useForm } from "react-hook-form";
import { changePasswordAction } from "../../../redux/actions/user/userAction";
import axiosInstance from "../../authentication/helper/axiosApi";
import { error } from "jquery";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

export const AccountSettings = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  // console.log(errors);
  const [oldPassword, setOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const password = useRef({});
  password.current = watch("password", "");
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   // DELETE ACCOUNT MODAL STATE
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleOpenDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleDeleteAccount = async () => {
    try {
      const token = localStorage.getItem("access_token");

      if (!token) {
        alert("Session expired. Please log in again.");
        window.location.href = "/login";
        return;
      }

      const response = await axiosInstance.delete("/api/user/delete/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // 204 No Content = success
      if (response.status === 204) {
        // alert("Your account has been deleted.");

        // clear local storage if needed
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");

        setShowDeleteModal(false);
        // navigate to home page
        window.location.href = "/";
      } else {
        alert("Failed to delete account.");
      }
    } catch (error) {
      console.log("Delete Account Error:", error);
      alert("Something went wrong!");
    }
  };



  const onSubmit = async (data, event) => {
    //const dateTime = new Date().toISOString();
    // console.log(data);
    //console.log(dateTime)
    //data.updated_at = dateTime
    console.log(data)
    
    if (Object.keys(errors).length === 0) {
      try {
        const response = await axiosInstance.post(
          `/api/user/changePassword/${props?.user?.id}/`,
          data
        );
        // console.log("Password change response:", response);
        if (
          response.data.Message ===
          "Your password has been successfully changed"
        ) {
          alert(response.data.Message);
          reset();
        } else {
          alert(response.data.Error);
        }
      } catch (error) {
        console.log("Error changing password:", error);
      }
    }
  };

  return (
    <UserLayout>
      
      <div className="right-section">
        <div className="row align-items-end mb-65">
          <div className="col-sm-12 col-12">
            <div className="banner">
              <div className="banner-title-overlay">
                <h5 style={ isMobile ? { paddingTop: "40px", marginLeft: "-10px"} : {}}>
                  <span>
                    MY
                    <br />
                    <b>Account</b>
                    <hr
                      style={{
                        height: "5px",
                        background: "white",
                        width: "75%",
                      }}
                    />
                  </span>
                </h5>
                <img
                  src="\assets\images\icons\myAccountIcon.png"
                  className="icon-image "
                />
              </div>

              <img
                className="banner-image"
                src="\assets\images\Asset 1.png"
                alt="Not Found"
              />
            </div>

            {/* <div className="myAccount-banner">
              <div class="banner-content">
                <h5 className="banner-title">
                  MY <br />
                  <strong>Account </strong>
                  <hr style={{ height: "10px", background: "white",width:'75%' }} />
                </h5>&nbsp;&nbsp;
                <span className="icon ">
                  <img src="\assets\images\icons\myAccountIcon.png" alt="" />
                </span>
              </div>
              <div className="banner-img">
              <img
                className="banner-image"
                src="\assets\images\Asset 1.png"
                alt="Not Found"
              /> 
              </div>
            </div> */}
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row margin-row">
            <div className="col-12 card-block">
              <div className="card-border">
                <div className="row">
                  <div className="col cmb-25">
                    <h3>Change Password</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <label className="field-label">Old Password</label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <input
                      type={oldPassword ? "text" : "password"}
                      className="form-control"
                      id="old_password"
                      placeholder="Old Password"
                      name="old_password"
                      autoComplete="off"
                      {...register("old_password", {
                        required: "Old Password is Required",
                      })}
                    />
                    <div className="input-group-append">
                      <button
                        onClick={() => setOldPassword(!oldPassword)}
                        className="btn btn-outline-secondary"
                        type="button"
                      >
                        Show
                      </button>
                    </div>
                  </div>
                  <p
                    style={{
                      color: "red",
                      marginLeft: "51%",
                      fontSize: "14px",
                    }}
                  >
                    {errors.old_password?.message}
                  </p>
                </div>
                {/* <p
                  style={{ color: "red", fontSize: "14px", float: "right" }}
                  className="col-md-5 col-10"
                >
                  {errors.old_password?.message}
                </p> */}
                <br></br>
                <div className="row ">
                  <div className="col-md-6 col-12">
                    <label className="field-label">New Password</label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      id="password"
                      placeholder="Password"
                      name="password"
                      autoComplete="off"
                      {...register("password", {
                        required: "Password is Required",
                        minLength: {
                          value: 8,
                          message: "Password must have at least 8 characters",
                        },
                        pattern: {
                          value: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(.*\W.*)/g,
                          message:
                            "Please Enter a one lower, one upper, one digit and one special character",
                        },
                        // pattern: { value: /[A-Z]/g, message: "Please Enter a upper character" },
                        // pattern: { value: /[0-9]/g, message: "Please Enter atleast one digit" },
                      })}
                    />

                    <div className="input-group-append">
                      <button
                        onClick={() => setShowPassword(!showPassword)}
                        className="btn btn-outline-secondary"
                        type="button"
                      >
                        Show
                      </button>
                    </div>
                    {/* <p style={{ color: "red" }}>{errors.password?.message}</p> */}
                  </div>
                  <p
                    style={{
                      color: "red",
                      marginLeft: "51%",
                      fontSize: "14px",
                    }}
                  >
                    {errors.password?.message}
                  </p>
                </div>
                {/* <p style={{ color: "red", fontSize: '14px', float: 'right' }} className="col-md-5 col-10">{errors.password?.message}</p> */}
                <br></br>
                <div className="row ">
                  <div className="col-md-6 col-12">
                    <label className="field-label">Confirm Password</label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <input
                      type={showConfirmPwd ? "text" : "password"}
                      className="form-control"
                      id="confirmpassword"
                      placeholder="Confirm Password"
                      name="confirmpassword"
                      autoComplete="off"
                      {...register("confirmPassword", {
                        required: "Confirm Password is Required",
                        validate: (value) =>
                          value === password.current ||
                          "The passwords do not match",
                      })}
                    />
                    <div className="input-group-append">
                      <button
                        onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                        className="btn btn-outline-secondary"
                        type="button"
                      >
                        Show
                      </button>
                    </div>
                  </div>{" "}
                  <p
                    style={{
                      color: "red",
                      marginLeft: "51%",
                      fontSize: "14px",
                    }}
                  >
                    {errors.confirmPassword?.message}
                  </p>
                </div>
                {/* <p style={{ color: "red", fontSize: '14px', float: 'right' }} className="col-md-5 col-10">{errors.confirmPassword?.message}</p> */}
                <br></br>
                <div className="cmb-25" style={{ float: "right" }}>
                  <button type="submit" className=" btn btn-blue">
                    Submit
                  </button>
                  
                </div>
                
              </div>
              {/* ---------------- DELETE ACCOUNT BUTTON ---------------- */}
                <div
                  style={{
                    textAlign: "center",
                    ...(isMobile
                      ? { marginTop: "10px" }
                      : { marginTop: "20px" })
                  }}
                >
                  <button
                    className="btn-danger"
                    style={{
                      padding: "10px 25px",
                      border: "none",
                      outline: "none",
                      boxShadow: "none",
                      borderRadius: "8px",
                      fontWeight: "600",
                    }}
                    onClick={handleOpenDeleteModal}
                    type="button"
                    onMouseDown={(e) => e.preventDefault()} // removes click outline
                  >
                    Delete Account
                  </button>

                  
                </div>

            </div>
          </div>
        </form>
      </div>
       {/* ---------- DELETE ACCOUNT CONFIRMATION MODAL ---------- */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Body style={{ textAlign: "center", padding: "30px" }}>
          <h4>Delete Account?</h4>
          <p style={{ color: "#666", marginTop: "10px" }}>
            Are you sure you want to delete your account?  
            <br />
            This action cannot be undone.
          </p>

          <div style={{ marginTop: "25px" }}>
            <Button
              variant="danger"
              onClick={handleDeleteAccount}
              // onClick={{}}
              style={{ marginRight: "15px", padding: "8px 25px" }}
            >
              Yes, Delete
            </Button>

            <Button
              variant="secondary"
              onClick={handleCloseDeleteModal}
              style={{ padding: "8px 25px" }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </UserLayout>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;

  return {
    user: user,
    user: user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (data, id) => dispatch(changePasswordAction(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
